<div class="card">
  <div class="card-body">
    <h5 class="card-title">{{model.Title}}</h5>
  </div>
  <div class="card-footer">
    <div class="arrow-right"></div>
    <a *ngIf="model.ExternalUrl == false" class="stretched-link" [routerLink]="[model.Url]">
    </a>
    <a *ngIf="model.ExternalUrl == true" [href]="[model.Url]" target="{{model.UrlOpenNew == true? '_blank':''}}" class="stretched-link">
    </a>
  </div>
</div>